import { hydrateApp } from '@qlean/web-widget-sdk/build/Client'

import App from '../app/App.svelte'

hydrateApp(__APP_NAME__, App)
